module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-04@2x.1768fe46.jpg";